export const ParticipationCancellationStatus = {
  Pending: 0,
  Approved: 1,
  Rejected: 2,
};

export const ParticipationCancellationStatusNames = {
  0: 'Beklemede',
  1: 'Onaylandı',
  2: 'Reddedildi',
};

export const LogoManualActionType = {
  DebtSlip: 'DebtSlip',
  CollectionSlip: 'CollectionSlip',
};

export const LogoManualActionTypeLabels = {
  DebtSlip: 'Borç fişi (04)',
  CollectionSlip: 'Tahsilat fişi (08)',
};

export const getParticipationCancellationStatusChipSx = (status) => {
  switch (status) {
    case ParticipationCancellationStatus.Approved:
      return { backgroundColor: '#DFFFEA', color: '#17C653' };
    case ParticipationCancellationStatus.Rejected:
      return { backgroundColor: '#FFEEF3', color: '#F8285A' };
    default:
      return { backgroundColor: '#E7EDF4', color: '#0E4D94' };
  }
};

export const buildRequestScopeSummary = (detail) => {
  if (!detail) return '-';
  const requesterType = detail.requesterPersonType ?? detail.requesterType;
  if (requesterType === 1) {
    return detail.requesterFullName || detail.requesterName || 'Yakın';
  }
  const parts = ['Üye'];
  if (detail.includeSpouse) parts.push('Eş');
  const guestCount = Array.isArray(detail.requestedGuests) ? detail.requestedGuests.length : 0;
  if (guestCount > 0) parts.push(`${guestCount} misafir`);
  return parts.join(' + ');
};

const normalizeText = (value) => (value || '').trim().toLocaleLowerCase('tr-TR');

export const filterPaymentLinesForRequest = (detail, paymentLines = []) => {
  if (!detail || !Array.isArray(paymentLines)) return [];

  const requestedGuests = Array.isArray(detail.requestedGuests) ? detail.requestedGuests : [];
  const requestedGuestIds = new Set(
    requestedGuests.map((guest) => guest.guestId || guest.id).filter(Boolean),
  );
  const requesterType = detail.requesterPersonType ?? detail.requesterType;

  return paymentLines.filter((line) => {
    const label = (line.personLabel || '').trim();
    const normalizedLabel = normalizeText(label);
    const personType = line.personType ?? line.PersonType;
    const lineGuestId = line.guestId || line.GuestId;

    if (requesterType === 1) {
      if (personType === 1) return true;
      if (normalizedLabel === 'eş') return true;
      const requesterName = normalizeText(detail.requesterFullName || detail.requesterName);
      return Boolean(requesterName && normalizedLabel === requesterName);
    }

    if (normalizedLabel === 'üye') return true;

    if (normalizedLabel === 'eş' || personType === 1) {
      return Boolean(detail.includeSpouse);
    }

    if (lineGuestId && requestedGuestIds.has(lineGuestId)) return true;

    if (requestedGuests.length > 0) {
      return requestedGuests.some((guest) => {
        const guestId = guest.guestId || guest.id;
        if (lineGuestId && guestId && lineGuestId === guestId) return true;
        const guestName = normalizeText(guest.fullName || guest.name);
        return Boolean(guestName && normalizedLabel === guestName);
      });
    }

    return false;
  });
};
